
export default {
    name: "RegionPageBlok",
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
}
